<div class="flex flex-col gap-1" [class]="sentByUser() ? 'items-end' : ''">
  <div
    class="markdown-message px-4 py-3 rounded-xl"
    [class]="messageClasses()"
    [innerHTML]="message().message | markdown"
  ></div>

  @if (showTime()) {
    <span class="text-xs text-muted-foreground">{{ message().timestamp | date: 'HH:mm' }}</span>
  }
</div>
